// Cached element references for the app shell (index.html provides these IDs).
import { state } from "./state.js";
import { dispAddr } from "./obf.js";

export const $ = (id) => document.getElementById(id);

export const tabsEl = $("rv-tabs");
export const contentEl = $("rv-content");
export const addrInput = $("rv-addr");
export const spinner = $("rv-spinner");
export const backBtn = $("rv-back");
export const fwdBtn = $("rv-fwd");
export const reloadBtn = $("rv-reload");
export const menuBtn = $("rv-menu");
export const newTabBtn = $("rv-newtab");
export const formEl = $("rv-form");
export const startEl = $("rv-start");
export const clockEl = $("rv-clock");
export const shortcutsEl = $("rv-shortcuts");
export const folderEl = $("rv-folder");
export const folderTitle = $("rv-folder-title");
export const folderSearch = $("rv-folder-search");
export const folderCats = $("rv-folder-cats");
export const folderClear = $("rv-folder-clear");
export const folderEmpty = $("rv-folder-empty");
export const folderPager = $("rv-folder-pager");
export const gridEl = $("rv-grid");
export const errorEl = $("rv-error");
export const loaderEl = $("rv-loader");
export const loaderLabel = $("rv-loader-label");
export const loaderSkip = $("rv-loader-skip");
export const greetingEl = $("rv-greeting");
export const dateEl = $("rv-date");
export const recentsEl = $("rv-recents");
export const jumpbackEl = $("rv-jumpback");
export const startSearch = $("rv-startsearch");
export const startSearchInput = $("rv-startsearch-input");

// Programmatic address-bar writes clear the editing flag so a page load can
// refine the URL; only user typing sets it.
export function setAddr(v) {
	if (addrInput) { addrInput.value = dispAddr(v); addrInput.dataset.real = v || ""; }
	state.editing = false;
}
